<template>
    <div class="ur-data-grid__content"><!-- ur-data-grid__content--empty -->
        <div class="ur-data-grid__content__scroll-wrapper" @scroll="onScroll" ref="scrollWrapper" :style="contentScrollWrapperStyle">
            <div class="ur-data-grid__content__row ur-data-grid__content--empty__row" :style="rowStyle">
                <span>{{gridInfo.opts.msgEmptyData}}</span>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name : "urDataGridContentEmpty",
    inject : ['gridInfo'],
    computed : {
        contentScrollWrapperStyle(){return {'overflow-x':'auto'};},
        rowStyle() {return {'width' : this.gridInfo.vars_tableWidth+'px'}}
        // 컬럼 수 많을 경우의 가로 스크롤 생성을 위해 아래 기존 옵션을 주석처리하고 윗 2줄 추가
        // rowStyle() {return {'width' : '100%'}}
    },
    methods : {
        onScroll() {
            // 1. set header scorll
            var scroll = this.$refs.scrollWrapper,
                header = this.gridInfo.refs.scrollHeader;
            header.scrollLeft = scroll.scrollLeft;
            // 2. set freeze column scroll
            /*if(!!this.freezeWidth) {
                var freeze = this.$refs.freezeWrapper
                freeze.scrollTop = scroll.scrollTop;
            }/**/
            // 3. remove context
            this.gridInfo.func.setHeaderContext(null);
        },
    }
}
</script>
